import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "omniClose",
  "use": "omniClose-usage",
  "viewBox": "0 0 18.999 18.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.999 18.999\" id=\"omniClose\"><g data-name=\"close (2)\"><path data-name=\"Path 12121\" d=\"M11.18 9.499l7.471-7.471a1.188 1.188 0 0 0-1.68-1.68L9.5 7.82 2.028.348a1.188 1.188 0 0 0-1.68 1.68L7.82 9.499.348 16.971a1.188 1.188 0 1 0 1.68 1.68L9.5 11.179l7.471 7.471a1.188 1.188 0 1 0 1.68-1.68z\" fill=\"#031425\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol